export const ProjectsImageOne = ({ pic }) => {
  return (
    <div className="projects-artwork-container">
      <img
        className="projects-artwork-image"
        src={pic}
        alt="pictures of the cotta website"
      ></img>
    </div>
  );
};
